<template>
    <div class="connector-card" :style="{ position: 'relative' }">
        <div class="connector-card-content" :class="{ active: isConnectorSelected }">
            <!--  <v-row align="center"> -->
            <div v-if="project.billingEnabled && !currentTariff" class="alert-icon">
                <v-img v-if="project.billingEnabled && !currentTariff" :src="dangerIcon" />
            </div>
            <v-avatar v-if="!loading && !loadingAvatar" :color="connectorAvatar.color" size="42" class="mx-2 my-2">
                <v-img style="position: absolute;" v-if="connector.image || connectorAvatar.image" transition="slide-x-transition" :src="connector.image || connectorAvatar.image" />
                <span>{{ connectorAvatar.symbol }}</span>
            </v-avatar>
            <v-progress-circular v-else indeterminate color="black" class="mx-2 my-3"></v-progress-circular>
            <div class="connector-card-name-wrapper">
                <h3 :title="connectorAvatar.name">{{ connectorAvatar.name }}</h3>
            </div>
            <span v-if="connector.isDraft"> (Draft)</span>
            <v-spacer></v-spacer>
            <v-tooltip v-if="showQrcode" bottom color="#000000DE">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        medium
                        class="qr-btn"
                        v-bind="attrs"
                        v-on="on"
                        @click="shareQrCode"
                    >
                        <v-icon class="qr-icon">mdi-qrcode-scan</v-icon>
                        <v-icon
                            v-if="statusIcon"
                            :class="['status-icon', statusIconColor]"
                        >
                            {{ statusIcon }}
                        </v-icon>
                    </v-btn>
                </template>
                <span class="white--text">Поделиться QR-кодом</span>
            </v-tooltip>
            <v-menu :close-on-content-click="true" offset-x offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        medium
                        v-bind="attrs"
                        v-on="on"
                        v-if="checkRole(connector.projectId, 'project:connector:edit') && !hideMenu"
                        :disabled="!checkRole(connector.projectId, 'project:connector:edit')"
                    >
                        <v-icon>mdi-dots-vertical</v-icon></v-btn
                    >
                </template>

                <v-card min-width="198px">
                    <v-list>
                        <v-list-item
                            class="text-btn-wrapper"
                            @click="finishConnectorCreate"
                            v-if="connector.isDraft && checkRole(project.id, 'project:connector:edit')"
                        >
                            <span class="mx-3 my-2">Завершить подключение</span>
                        </v-list-item>
                        <v-list-item
                            class="text-btn-wrapper"
                            @click="openConnectorSettings"
                            v-if="!connector.isDraft && checkRole(project.id, 'project:connector:edit')"
                        >
                            <span class="mx-3 my-2">Настройки</span>
                        </v-list-item>

                        <v-list-item
                            v-if="isTester"
                            class="text-btn-wrapper"
                            @click="deleteConnector"
                        >
                            <span class="mx-3 my-2">Удалить</span>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
            <!--   </v-row> -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkAccess } from '@/utils'
import { checkRole } from '@root/src/helpers/roles'
import { computed, onMounted } from 'vue'
import { useBillingStore } from '@root/src/store/stores/billing'
import { useProject } from '@root/src/hooks/useProject'
import api from '@root/src/api/api'
import { CONNECTOR_TYPES, PROVIDER_TYPES, CHANNEL_TYPES } from '@root/src/vars/general'
import cfg from '../../../config'
export default {
    name: 'connectorCard',
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        connector: {
            type: Object,
            default: () => {},
        },
        selectedConnectors: {
            type: Array,
            default: () => [],
        },
    },
    components: {},
    data: () => ({
        connectorAvatar: {},
        loadingAvatar: false,
        channelType: null,
        authStatus: null,
        aliveStatusInterval: null
    }),
    computed: {
        ...mapGetters(['connectorAvatarByType']),
        project() {
            const projectId = this.$router.currentRoute.params.id
            return this.$store.getters.projectById(projectId)
        },
        isConnectorSelected() {
            return this.selectedConnectors.includes(this.connector.connectorId)
        },
        dangerIcon() {
            return require('@/assets/danger-icon.svg')
        },
        isTester() {
            return cfg.testerEmails.includes(this.$auth.user.email)
        },
        hideMenu() {
            return this.connector.connectorType === CONNECTOR_TYPES.telegramHr || this.connector.connectorType === CONNECTOR_TYPES.telegramHrBranch
        },
        showQrcode() {
            return this.connector.connectorType === CONNECTOR_TYPES.whatsappBasis && ['basis-api', 'wApi-telegram', 'wApi-whatsapp', 'green-api-max'].includes(this.channelType)
        },
        statusIcon() {
            if (this.authStatus === 'auth') {
                return 'mdi-check-bold'
            }
            if (this.authStatus === 'no_auth') {
                return 'mdi-exclamation-thick'
            }
            return null
        },
        statusIconColor() {
            if (this.statusIcon === 'mdi-check-bold') {
                return 'status-icon--success'
            }
            if (this.statusIcon === 'mdi-exclamation-thick') {
                return 'status-icon--error'
            }
            return ''
        },
    },
    setup(props, context) {
        const { project } = useProject()
        const billingStore = computed(() => useBillingStore())
        const currentTariff = computed(() => billingStore.value.getCurrentTariff(project.value.id))
        return {
            currentTariff,
            project,
        }
    },
    methods: {
        checkAccess,
        checkRole,
        deleteConnector() {
            this.$emit('deleteConnector', this.connector.connectorId)
        },
        openConnectorSettings() {
            this.$emit('openConnectorSettings', this.connector.connectorId)
        },
        finishConnectorCreate() {
            this.$store.commit('project/setLoggedAddingConnector', this.connector)
            this.$store.commit('project/updateCurrentAddingConnector', this.connector)
            
            // Проверяем, является ли коннектор каналом
            const isChannel = Object.values(CHANNEL_TYPES).includes(this.connector.connectorType)            
            if (isChannel) {
                this.$router.push(`/project/${this.connector.projectId}/addChannelStage3?complete=true`)
            } else {
                this.$router.push(`/project/${this.connector.projectId}/addConnectorStage3?complete=true`)
            }
        },
        getChannelIndex(channelType) {
            // Индексируем только каналы с connectorType из CHANNEL_TYPES
            // Определяем группу на основе CHANNEL_TYPES
            let targetChannelType = null
            if (channelType === CHANNEL_TYPES.whatsappChannel ||
                channelType === PROVIDER_TYPES.whatsappApi ||
                channelType === PROVIDER_TYPES.whatsappBasis ||
                channelType === PROVIDER_TYPES.whatsapp ||
                channelType === PROVIDER_TYPES.whatsappDh ||
                channelType === CONNECTOR_TYPES.whatsapp) {
                targetChannelType = CHANNEL_TYPES.whatsappChannel
            } else if (channelType === CHANNEL_TYPES.telegramChannel || 
                       channelType === PROVIDER_TYPES.telegramApi || 
                       channelType === PROVIDER_TYPES.telegramDh) {
                targetChannelType = CHANNEL_TYPES.telegramChannel
            } else if (channelType === CHANNEL_TYPES.maxChannel || 
                       channelType === PROVIDER_TYPES.maxBasis ||
                       channelType === PROVIDER_TYPES.maxDh) {
                targetChannelType = CHANNEL_TYPES.maxChannel
            } else {
                return 1
            }
            
            // Находим все подключенные каналы WhatsApp, включая WhatsApp (рассылки)
            // Сортируем по дате создания
            const channelsInGroup = this.project.connectors
                .filter(c => {
                    if (!c.isChisai) {
                        // Для WhatsApp группы учитываем как каналы (CHANNEL_TYPES.whatsappChannel), 
                        // так и коннектор WhatsApp (рассылки) (CONNECTOR_TYPES.whatsapp)
                        if (targetChannelType === CHANNEL_TYPES.whatsappChannel) {
                            return c.connectorType === targetChannelType ||
                                   c.connectorType === CONNECTOR_TYPES.whatsapp ||
                                   (c.providerType && (c.providerType === PROVIDER_TYPES.whatsappBasis ||
                                                       c.providerType === PROVIDER_TYPES.whatsappApi ||
                                                       c.providerType === PROVIDER_TYPES.whatsapp ||
                                                       c.providerType === PROVIDER_TYPES.whatsappDh))
                        }
                        // Для остальных групп - только каналы с connectorType из CHANNEL_TYPES
                        return c.connectorType === targetChannelType
                    }
                    return false
                })
                .sort((a, b) => {
                    // Если createdAt отсутствует или равен 0, используем очень большое число,
                    // чтобы такие каналы попадали в конец списка (они новые и еще не сохранены на сервере)
                    const aTime = a.createdAt && a.createdAt > 0 ? a.createdAt : Number.MAX_SAFE_INTEGER
                    const bTime = b.createdAt && b.createdAt > 0 ? b.createdAt : Number.MAX_SAFE_INTEGER
                    // Если оба имеют валидный createdAt, сортируем по нему
                    if (aTime !== Number.MAX_SAFE_INTEGER && bTime !== Number.MAX_SAFE_INTEGER) {
                        return aTime - bTime
                    }
                    // Если один из них не имеет createdAt, он должен быть в конце
                    if (aTime === Number.MAX_SAFE_INTEGER && bTime !== Number.MAX_SAFE_INTEGER) {
                        return 1
                    }
                    if (aTime !== Number.MAX_SAFE_INTEGER && bTime === Number.MAX_SAFE_INTEGER) {
                        return -1
                    }
                    // Если оба не имеют createdAt, сортируем по connectorId (лексикографически)
                    return a.connectorId.localeCompare(b.connectorId)
                })
            
            // Определяем индекс текущего канала (начиная с 1)
            const currentIndex = channelsInGroup.findIndex(c => c.connectorId === this.connector.connectorId)
            return currentIndex >= 0 ? currentIndex + 1 : 1
        },
        getChannelDisplayName(channelType, index) {
            const baseNames = {
                [PROVIDER_TYPES.whatsappBasis]: 'WhatsApp',
                [PROVIDER_TYPES.whatsappApi]: 'WhatsApp',
                [PROVIDER_TYPES.whatsapp]: 'WhatsApp',
                [PROVIDER_TYPES.whatsappDh]: 'WhatsApp',
                [PROVIDER_TYPES.telegramApi]: 'Telegram',
                [PROVIDER_TYPES.telegramDh]: 'Telegram',
                [PROVIDER_TYPES.maxBasis]: 'MAX',
                [PROVIDER_TYPES.maxDh]: 'MAX',
            }
            const baseName = baseNames[channelType] || channelType
            
            // Первый экземпляр (index === 1) без индекса, остальные с индексом
            if (index === 1) {
                return baseName
            }
            
            // Остальные экземпляры с индексом
            return `${baseName} ${index}`
        },
        async shareQrCode () {
            const res = await api.networkFixer.getNoAuthToken({connectorId: this.connector.connectorId})
            let token
            if (!res.error) {
                token = res.data.token
                const isChannelsRework = this.project?.isChannelsRework ? 'true' : 'false'
                const qrCodeUrl = `${window.location.origin}/qr/${this.connector.connectorId}?token=${token}&isChannelsRework=${isChannelsRework}&provider=${this.channelType}`
                await navigator.clipboard.writeText(qrCodeUrl)
                window.open(qrCodeUrl, '_blank')
                this.$store.dispatch('callNotify', 'Ссылка скопирована в буфер обмена')
            } else {
                this.$store.dispatch('callNotify', 'Ошибка открытии страницы с кодом')
            }
        },
        async checkAliveStatus () {
            const { data, error } = await api.networkFixer.getAuthStatus({ connectorId: this.connector.connectorId })
            if (!error) {
                this.authStatus = data?.alive
            }
        }
    },

    async created() {
        if (this.connector.connectorType === CONNECTOR_TYPES.whatsappBasis) {
            this.loadingAvatar = true
            this.checkAliveStatus()
            // Запускаем интервальный опрос статуса каждые 10 секунд
            this.aliveStatusInterval = setInterval(() => {
                this.checkAliveStatus()
            }, 10 * 1000)
            const [app, error] = await api.networkFixer
                .getApp({ connectorId: this.connector.connectorId })
                .then(res => [res.data?.data, res.error])
            this.channelType = Object.keys(app?.channel)[0]
            if ((app?.channel?.['wApi-telegram']?.credentials || app?.channel?.['dh-telegram']?.credentials) && !error) {
                // Добавляем звездочку если isChannelsRework === true
                const name = this.project.isChannelsRework ? 'Telegram *' : 'Telegram'
                this.connectorAvatar = {
                    color: '#229ED9',
                    symbol: 'Tg',
                    name: name,
                    image: require('@/assets/img/messenger-logo/telegram-logo.png')
                }
            } else if (app?.channel?.['green-api-max']?.credentials && !error) {
                // Добавляем звездочку если isChannelsRework === true
                const name = this.project.isChannelsRework ? 'MAX *' : 'MAX'
                this.connectorAvatar = {
                    color: '#2492f4',
                    symbol: 'MAX',
                    name: name,
                    image: require('@/assets/img/messenger-logo/max-logo.png')
                }
            } else {
                const defaultAvatar = this.connectorAvatarByType(CONNECTOR_TYPES.whatsappBasis)
                // Добавляем звездочку если isChannelsRework === true
                if (this.project.isChannelsRework) {
                    this.connectorAvatar = {
                        ...defaultAvatar,
                        name: `${defaultAvatar.name} *`
                    }
                } else {
                    this.connectorAvatar = defaultAvatar
                }
            }
            this.loadingAvatar = false
        } else {
            // Для каналов определяем тип для поиска аватара
            // Проверяем: либо connectorType из CHANNEL_TYPES, либо providerType из PROVIDER_TYPES, либо старый connectorType из PROVIDER_TYPES
            const isWhatsappBasis = this.connector.connectorType === CONNECTOR_TYPES.whatsappBasis
            
            const isChannel = Object.values(CHANNEL_TYPES).includes(this.connector.connectorType) ||
                             (this.connector.providerType && Object.values(PROVIDER_TYPES).includes(this.connector.providerType)) ||
                             Object.values(PROVIDER_TYPES).includes(this.connector.connectorType)
            
            // Для каналов используем connectorType (из CHANNEL_TYPES) для поиска аватара
            // Для остальных коннекторов используем connectorType как есть
            const avatarType = isChannel ? this.connector.connectorType : this.connector.connectorType
            const baseAvatar = this.connectorAvatarByType(avatarType) || {
                color: 'white',
                symbol: '404',
                name: 'Не найдено',
            }
            
            if (isChannel) {
                // Используем providerType если есть, иначе connectorType (для старых коннекторов)
                const providerType = this.connector.providerType || this.connector.connectorType
                
                // Новая логика нумерации только для isChannelsRework
                if (this.project.isChannelsRework) {
                    // Для whatsappBasis не учитываем при индексации (логика уже в getChannelIndex)
                    // Но отображаем его как обычный канал - имя уже установлено в created()
                    if (!isWhatsappBasis) {
                        const channelIndex = this.getChannelIndex(providerType)
                        this.connectorAvatar = {
                            ...baseAvatar,
                            name: this.getChannelDisplayName(providerType, channelIndex)
                        }
                    }
                    // Для whatsappBasis имя уже установлено в created(), ничего не делаем
                } else {
                    // Старая логика - просто базовое имя без нумерации
                    this.connectorAvatar = baseAvatar
                }
            } else {
                this.connectorAvatar = baseAvatar
            }
        }
    },
    mounted() {},
    beforeDestroy() {
        // Очищаем интервал при размонтировании компонента
        if (this.aliveStatusInterval) {
            clearInterval(this.aliveStatusInterval)
            this.aliveStatusInterval = null
        }
    }
}
</script>

<style lang="sass" scoped>
.active
    background-color: #0000001F
.connector-card
    width: 328px
    border: 1px solid #0000001F
    border-radius: 4px
.connector-card-name-wrapper
    text-overflow: ellipsis
    white-space: nowrap
    overflow: hidden
    max-width: 175px
.connector-card-content
    padding-left: 16px
    padding-right: 16px
    padding-top: 7px
    padding-bottom: 7px
    display: flex
    flex-direction: row
    align-items: center
button:focus
    outline: 0
.alert-icon
    width: 12px
    height: 12px
    min-width: 12px
    min-height: 12px
    border-radius: 50%
    position: absolute
    right: 6px
    top: 6px
    display: flex
    justify-content: center
    align-items: center
.qr-btn
    position: relative
.qr-icon
    font-size: 28px !important
.status-icon
    position: absolute
    top: 1px
    right: 6px
    text-shadow: -1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF
.status-icon--success
    color: #00C853 !important
    font-size: 20px !important
    
.status-icon--error
    right: 7px
    color: red !important
    font-size: 22px !important
</style>
